import {
  SELECIONAR_VALOR_DESCONTO_CALCULADO
} from '../../actions/types';

const initialState = {ida:0.00, volta:0.00}

export default function reducerSelecionarValorDescontoCalculado (state = initialState, action) {
  switch (action.type) {
    case SELECIONAR_VALOR_DESCONTO_CALCULADO: {
      return action.payload
    }
    default:
      return state
  }
}
